<template lang="pug">
	.station--row-item.flex-row.align-center.space(v-if="item")
		img(v-if="item.HasImage", :src="stationLogoUrl")
		.flex-col
			span {{item.Name}}
			.font-small(v-if="item.Slogan") {{item.Slogan}}
</template>

<script>
	

	export default {
		translationCategory: 'station.RowItem',
		name: 'station-row-item',
		components: {
			
		},
		props: ['item'],
		data() {
			return {
				
			};
		},
		computed: {
            stationLogoUrl() {
				return this.$Data.getMethodUrl(`externalApi?accessToken=${this.$auth.accessToken()}&method=Station/GetStationImage&parameters=${encodeURIComponent(`stationId=${this.item?.Oid}`)}`);
			},
		},
		watch: {
			
		},
		mounted() {
			if (__DEBUG__)
				window.stationRowItem = this;
		},
		methods: {
			
		}
	};
</script>

<style lang='scss'>
	.station--row-item {
		img {
			max-width: 50px;
			max-height: 50px;
		}
	}
</style>
